import React from 'react';
import { string } from 'prop-types';

import * as helpers from './helpers';

const ClockIcon = ({ color, ...props }) => (
  <svg {...helpers.getSvgDimensionsProps(props)} {...props}>
    <path
      fill={color}
      d="M10.537 3.92l.546-.555.162.164a.38.38 0 0 0 .544 0 .394.394 0 0 0 0-.553l-.816-.83a.38.38 0 0 0-.545 0 .397.397 0 0 0 0 .554l.18.182-.536.545a5.939 5.939 0 0 0-3.479-1.59v-.509h.389c.36 0 .653-.298.653-.663A.66.66 0 0 0 6.982 0h-1.96a.66.66 0 0 0-.654.665c0 .366.293.663.654.663h.43v.507h-.024a5.942 5.942 0 0 0-3.642 1.73l-.333.367A6.126 6.126 0 0 0 0 7.902C0 11.27 2.687 14 6 14c3.315 0 6-2.73 6-6.097a6.12 6.12 0 0 0-1.463-3.982zm-4.544 9.037c-2.753 0-4.985-2.268-4.985-5.065 0-2.798 2.232-5.066 4.985-5.066 2.752 0 4.984 2.268 4.984 5.066 0 2.797-2.232 5.065-4.984 5.065z"
    />
    <path
      fill={color}
      d="M6.506 7.617V4.565L6.033 4l-.538.565v3.052c-.295.13-.495.366-.495.64C5 8.666 5.448 9 6 9c.55 0 1-.333 1-.744.001-.273-.198-.51-.494-.64z"
    />
  </svg>
);

ClockIcon.propTypes = {
  color: string.isRequired,
  ...helpers.iconDimensionsPropTypes,
};

ClockIcon.defaultProps = {
  ...helpers.getDefaultIconDimensionsProps(12, 14),
};

export default ClockIcon;



// WEBPACK FOOTER //
// ./src/components/svg-icon/icons/clock.js